<template>
    <HeaderBar></HeaderBar>
    <div class="ab_main">
        <div class="ab_side">
            <a v-for="item in items" :class="item.class" v-on:click="showContent(item.id)" v-bind:key="item.id">{{ item.text }}</a>
        </div>
        <div class="ab_content">
            <router-view/>
        </div>
    </div>
    <FooterBar></FooterBar>
</template>

<script>
import HeaderBar from '@/components/HeaderBar.vue';
import FooterBar from '@/components/FooterBar.vue';
    export default {
        name: 'AboutUs',
        components:{
            HeaderBar,
            FooterBar
        },
        data(){
            return{
                show_item:"aboutus",
                show_item_class:"item_title",
                items:[
                    {"text":"关于我们","id":"","class":"item_title_selected"},
                    {"text":"联系我们","id":"/contact","class":"item_title"},
                    {"text":"免责声明","id":"/statement","class":"item_title"}
                ]
            }
        },
        mounted(){
            this.setShowItem()
        },
        methods:{
            setShowItem(){
                var p_path=this.$route.path;
                p_path = p_path.replace("/about","");
                console.log(p_path)
                this.items.forEach(item =>{
                    item.class="item_title";
                    if(p_path==item.id){
                        item.class="item_title_selected";
                    }
                });
            },
            showContent(id){
                this.$router.replace({ path: "/about"+id, replace: true });
                this.items.forEach(item =>{
                    item.class="item_title";
                    if(id==item.id){
                        item.class="item_title_selected";
                    }
                });
            }
        }
    }
</script>
<style>
.ab_main{
    display: flex;
    flex-direction: row;
    margin: 0px auto;
    width: 1280px;
    margin-top: 70px;
    min-height: calc(100vh - 127px);
}
.ab_side{
    width: 240px;
    height: 360px;
    margin-right: 20px;
    margin-bottom: 10px;
    border-top:1px solid #DEE3EB;
}
.ab_side a{
    display: block;
    border-bottom:1px dotted #b3b7bd;
    color: #404040;
    padding-bottom: 5px;
}
.ab_side a:hover{
    color: #000000;
}
.item_title,.item_title_selected{
    margin: 5px 0px;
}
.item_title_selected{
    background: url('../assets/right.png') no-repeat;
    background-position: right 50px center;
    background-size:16px 16px;
}
.ab_content{
    max-width: 960px;
    margin-bottom: 10px;
    border:1px solid #DEE3EB;
    width: 100%;
}
.ab_content div{
    color: gray;
    padding: 10px;
    max-width: 940px;
}
.ab_content div h4{
    font-size: 14px;
}
.ab_content div p{
    margin: 0px;
    padding: 0px;
    font-size: 12px;
    line-height: 25px;
    word-wrap: break-word;
}
</style>